import React from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

const Return = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        background: "#f4f6f8",
        minHeight: "100vh",
        padding: "40px 0",
      }}
    >
      <div
        style={{
          maxWidth: "800px",
          margin: "auto",
          background: "#fff",
          borderRadius: "12px",
          padding: "40px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
        }}
      >
        {/* Back Button */}
        <button
          className="btn btn-md d-flex align-items-center gap-2 fw-bold text-muted border-0 bg-transparent mb-3"
          onClick={() => navigate("/")}
        >
          <FaArrowLeft /> Back
        </button>

        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: "20px" }}>
          <span
            style={{
              background: "#e6f4f1",
              color: "#097969",
              padding: "6px 14px",
              borderRadius: "20px",
              fontSize: "12px",
              fontWeight: "600",
            }}
          >
            COMPLIANCE DOCUMENT
          </span>

          <h1 style={{ color: "#097969", marginTop: "10px" }}>
            Return & Refund Policy
          </h1>

          <p style={{ color: "#666" }}>
            Effective Date: March 15, 2024
          </p>
        </div>

        <hr />

        {/* Intro */}
        <p style={{ marginTop: "20px", color: "#444" }}>
          At <b>Shreenath NX</b>, we aim to provide quality school uniforms.
          Please read our return and refund policy carefully.
        </p>

        {/* Sections */}
        {sections.map((sec, i) => (
          <div key={i} style={{ marginTop: "20px" }}>
            <h3 style={{ color: "#097969" }}>
              {i + 1}. {sec.title}
            </h3>
            <p style={{ color: "#555" }}>{sec.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

// Data
const sections = [
  {
    title: "Return Eligibility",
    text: "Items can be returned only if they are unused, unworn, and in original packaging.",
  },
  {
    title: "Return Timeframe",
    text: "Returns must be requested within 7 days of delivery.",
  },
  {
    title: "Non-Returnable Items",
    text: "Customized or altered uniforms are not eligible for return.",
  },
  {
    title: "Refund Process",
    text: "Refunds will be processed after inspection of returned items.",
  },
  {
    title: "Refund Time",
    text: "Refunds are credited within 5-7 working days to the original payment method.",
  },
  {
    title: "Shipping Charges",
    text: "Shipping charges are non-refundable unless the product is defective.",
  },
  {
    title: "Damaged Products",
    text: "If you receive a damaged or wrong item, contact us immediately for replacement.",
  },
  {
    title: "Contact",
    text: "For return requests, contact us via our official website.",
  },
];

export default Return;